<template>
  <div class="main-container">
    <div class="search-box">
      <div class="input-item">
        <span class="label">预约签单日期</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          :editable="false"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchParams.appointSignDate"
          @on-change="searchParams.appointSignDate = $event"
        ></DatePicker>
      </div>
      <div class="input-item">
        <span class="label">投保人姓名</span>
        <Input type="text" v-model="searchParams.name" placeholder="请输入" clearable />
      </div>
      <div class="input-item">
        <span class="label">预约编号</span>
        <Input type="text" v-model="searchParams.reservationNo" placeholder="请输入" clearable />
      </div>
      <div class="input-item">
        <span class="label">保险公司</span>
        <Select v-model="searchParams.companyId" clearable filterable @on-change="companyChange()">
          <Option v-for="(item, index) in companyList" :value="item.id" :key="index">{{ item.name }}</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">产品名称</span>
        <Select v-model="searchParams.productId" clearable filterable>
          <Option v-for="(item, index) in searchProductList" :value="item.id" :key="index">{{ item.name }}</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">投保人手机号</span>
        <Input type="text" v-model="searchParams.mobile" placeholder="请输入" clearable />
      </div>
      <div class="input-item">
        <span class="label">受保人姓名</span>
        <Input type="text" v-model="searchParams.insuranceName" placeholder="请输入" />
      </div>
      <div class="input-item">
        <span class="label">{{ isIFA ? '归属团队' : '转介人' }}</span>
        <select-tree
          v-model="searchParams.id"
          type="5"
          url="/buz/merchant/read/tree"
          :params="{ nodeType: 0 }"
          :isAll="true"
          ref="selectTree"
          @change="changeTenant"
        />
      </div>
      <div class="input-item">
        <span class="label">申请人</span>
        <Select v-model="searchParams.agentId" clearable filterable>
          <Option v-for="item in userList" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
      </div>
      <div class="btn-item">
        <Button type="primary" @click="searchAjax()">查询</Button>
        <Button type="primary" ghost @click="resetSearch()">重置</Button>
      </div>
    </div>
    <div class="tools-box">
      <div class="tools-box btns-left">
        <!-- <Button type="primary" @click="goDetail()">新增</Button>
        <Upload
          ref="upload"
          :show-upload-list="false"
          accept=".xlsx,.xls"
          :on-success="handleSuccess"
          :before-upload="handleBeforeUpload"
          multiple
          action="/buz/reservation/import"
        >
          <Button type="primary" ghost>导入</Button>
        </Upload>
        <Button type="primary" ghost @click="handleDownloadTemplate()">模板下载</Button> -->
      </div>
      <div>
        <Button type="primary" ghost @click="daochu">导出</Button>
      </div>
    </div>
    <Tabs v-model="searchParams.status" :animated="false" @on-click="onChangeTab">
      <TabPane :label="() => getNumText('全部', 'null')" name="null"></TabPane>
      <TabPane :label="() => getNumText('待完善', 0)" name="0"></TabPane>
      <TabPane :label="() => getNumText('预约中', 1)" name="1"></TabPane>
      <TabPane :label="() => getNumText('预约成功', 2)" name="2"></TabPane>
      <TabPane :label="() => getNumText('已签单', 3)" name="3"></TabPane>
      <TabPane :label="() => getNumText('取消预约', -1)" name="-1"></TabPane>
    </Tabs>

    <div class="table-box setTable">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <!-- 签单地点 -->
        <template slot-scope="{ row }" slot="signAddr">
          <lzDicTxt dicType="SIGNING_CITY" :dicCode="row.signAddr"></lzDicTxt>
        </template>
        <!-- TR -->
        <template slot-scope="{ row }" slot="TR">
          <trTag v-if="row.trInfo && row.trInfo.englishName" :name="row.trInfo.englishName" :classType="row.trInfo.classType" />
          <!-- <span v-if="row.classType && row.signPersonNamePy" :class="row.classType ? 'my-tag tr ' + row.classType : ''">{{ row.signPersonNamePy }}</span> -->
          <span v-else>{{ row.signPersonName }}</span>
        </template>
        <!-- 签约保单号 -->
        <template slot-scope="{ row }" slot="policyNo">
          <span class="table-btn" @click="goPolicy(row)" v-if="row.policyNo">{{ row.policyNo }}</span>
          <span class="table-btn disabled" v-else>暂未生成</span>
        </template>
        <template slot-scope="{ row }" slot="currencyType">
          <lzDicTxt dicType="CURRENCY" :dicCode="row.currency"></lzDicTxt>
        </template>
        <template slot-scope="{ row }" slot="name">
          <span> {{ row.name }} </span>
        </template>
        <!-- 年缴保费 -->
        <template slot-scope="{ row }" slot="fee">
          <div v-if="row.fee || row.paymentPeriod">
            <span>{{ row.fee }}</span>
            <lzDicTxt dicType="CURRENCY_INT" :dicCode="row.currencyType" />
            <span v-if="row.fee && (row.paymentPeriod || row.paymentType)">/</span>
            <span>{{ row.paymentPeriod }}</span>
            <lzDicTxt v-if="row.paymentType" :dicCode="row.paymentType" dicType="GUARANTEE_TYPE"></lzDicTxt>
            <span v-else>年</span>
          </div>
          <div v-else>-</div>
        </template>
        <!-- 预约状态 -->
        <template slot-scope="{ row }" slot="status">
          <span class="my-tag" v-if="row.status == 0">待完善</span>
          <span class="my-tag org" v-if="row.status == 1">预约中</span>
          <span class="my-tag green" v-if="row.status == 2">预约成功</span>
          <span class="my-tag blue" v-if="row.status == 3">已签单</span>
          <span class="my-tag" v-if="row.status == -1">取消预约</span>
        </template>
        <template slot-scope="{ row }" slot="action">
          <span @click="goDetail(row)" class="table-btn"> 详情 </span>
          <span @click="jumpTrip(row)" class="table-btn" v-if="row.status == 2 && getIsMe(row)"> 下载行程单 </span>
          <span @click="del(row)" class="table-btn red" v-if="[0, -1].includes(row.status * 1) && getIsMe(row)"> 删除 </span>
        </template>
      </Table>
      <Page
        :total="total"
        :current="pageNum"
        :page-size="pageSize"
        show-total
        @on-change="getList"
        :page-size-opts="[10, 20, 30, 50, 100]"
        style="text-align: center"
      />
    </div>
    <validUserName ref="validUserNameRef" @success="(...params) => openEye(...params)" />
  </div>
</template>

<script>
import selectTree from '@/components/system/selectTree3';
import lzDicTxt from '@/components/commons/lzDicTxt';
import lzSelect from '@/components/commons/lzSelect';
import { pageTool, common } from '@/api/mixins';
import { config } from './index.config.js';
import validUserName from '@/components/commons/validUserName';
import trTag from '@/components/commons/trTag';

const userInfo = JSON.parse(localStorage.getItem('userInfo'));

export default {
  mixins: [pageTool, common, config],
  components: {
    trTag,
    selectTree,
    lzSelect,
    lzDicTxt,
    validUserName
  },
  data() {
    return {
      userInfo,
      statistics: {}, // 统计数据
      currencyTypes: JSON.parse(localStorage.dic)['CURRENCY_TYPE'], // 货币种类
      companyList: [],
      searchProductList: [],
      userList: [],
      searchParams: {
        status: 'null',
        appointSignDate: []
      }
    };
  },
  computed: {
    isIFA() {
      return this.userInfo.isIFA;
    }
  },
  created() {
    this.getColumns();
  },
  mounted() {
    this.initListParams('/buz/reservation/list');
  },
  activated() {
    this.queryCompanyList();
    this.companyChange();
    this.getList();
    this.getUserList();
  },
  methods: {
    changeTenant(data) {
      console.log(data);
      if (data.nodeType == 1) {
        this.$set(this.searchParams, 'groupId', '');
        this.$set(this.searchParams, 'tenantId', data.id);
      } else if (data.nodeType == 2) {
        this.$set(this.searchParams, 'groupId', data.id);
        this.$set(this.searchParams, 'tenantId', data.parentId);
      } else {
        this.$set(this.searchParams, 'groupId', '');
        this.$set(this.searchParams, 'tenantId', '');
      }
      this.$set(this.searchParams, 'agentId', '');
      this.getUserList();
    },
    // 解密
    openEye(row) {
      if (!row['validName']) {
        this.$refs.validUserNameRef.open(row);
        return;
      }
      if (!row.eyeShow) {
        this.descrypt(
          {
            query: row.id,
            customerType: 1,
            operationFunction: 14,
            operationType: 2
          },
          row,
          'mobileFuzz'
        ).then(() => {
          this.$set(row, 'eyeShow', true);
        });
      }
    },
    onChangeTab() {
      this.searchAjax();
    },
    handleBeforeUpload(file) {
      if (!/\.(xlsx?)$/.test(file.name.toLowerCase())) {
        this.$Message.error('上传格式不正确');
        return false;
      }
      if (this.uploadFileMsg) {
        this.uploadFileMsg();
        this.uploadFileMsg = null;
      }
      this.uploadFileMsg = this.$Message.loading({
        content: '正在上传',
        duration: 0
      });
    },
    handleSuccess(res, file) {
      if (this.uploadFileMsg) {
        this.uploadFileMsg();
        this.uploadFileMsg = null;
      }
      if (res.httpCode != 1) {
        let msgStr = res.msg;
        try {
          msgStr = res.msg.split('\n').join('<br/>');
        } catch (e) {}
        this.$Modal.warning({
          title: '提示',
          content: '<div class="error-msg">' + msgStr + '</div>'
        });
      } else {
        this.uploadFileMsg = this.$notice.success('上传成功');
        sessionStorage.setItem('import_appt_data', JSON.stringify(res.data));
        setTimeout(() => {
          this.goDetail({}, 1);
        }, 500);
      }
    },
    handleDownloadTemplate() {
      this.$http({
        url: '/buz/reservationTemplate/read/list',
        type: 'POST',
        data: {}
      }).then(res => {
        if (res.httpCode === 1) {
          try {
            const list = JSON.parse(res.data[0].fileJson);
            this.$units.downloadFun({ url: '/upload/downloadByUrl', params: { url: list[0].path } }, '预约模版.xlsx');
          } catch (err) {
            console.error(err);
            this.$Message.error('下载文件失败');
          }
        }
      });
    },
    // 选择保司，查询产品
    companyChange() {
      this.$http({
        url: '/buz/product/query/list',
        type: 'GET',
        data: { companyId: this.searchParams.companyId }
      }).then(res => {
        this.searchProductList = res.data;
      });
    },
    // 查询申请人
    getUserList() {
      this.$http({
        url: '/buz/userBase/list',
        type: 'POST',
        data: {
          selectSub: 1,
          tenantId: this.searchParams.tenantId,
          groupId: this.searchParams.groupId
        }
      }).then(res => {
        this.userList = res.data.filter(i => i.ifaType != 2);
      });
    },
    // 查询所有保司
    queryCompanyList() {
      this.$http({
        url: '/buz/insuranceCompany/query/list',
        type: 'GET',
        data: {}
      }).then(res => {
        this.companyList = res.data;
      });
    },
    // 跳转保单详情
    goPolicy(row) {
      if (!row.policyId) {
        this.$notice.error('policyId不存在');
        return;
      }
      this.openPageTabTags('/operate/orderManage/insuredOrder/policyDetail', {
        backUrl: this.$route.fullPath,
        id: row.policyId,
        reqUrl: 'read/detail'
      });
    },
    // 跳转详情
    goDetail(data = {}, useData = 0) {
      this.openPageTabTags('/operate/appointmentManager/detail', {
        id: data.id || '',
        useData,
        time: Date.now(),
        canEdit: data.tenantId ? Number(userInfo.tenantId === data.tenantId) : 1
      });
    },
    // 设置参数
    setListParams(params) {
      // 预约签单日期
      if (params.appointSignDate && params.appointSignDate[0]) {
        params.appointSignDateStart = params.appointSignDate[0];
        params.appointSignDateEnd = params.appointSignDate[1];
      }
      delete params.appointSignDate;
      if (params.status == 'null') {
        delete params.status;
      }
      delete params.id;
      window.setTimeout(() => {
        this.getStatistics(params); //获取统计数据
      }, 300);
    },
    listCallback() {
      this.getColumns();
    },
    // 获取统计数据
    getStatistics(params) {
      params = JSON.parse(JSON.stringify(params));
      delete params.status;
      this.$http({
        url: '/buz/reservation/statistics',
        type: 'POST',
        data: params
      }).then(res => {
        this.statistics = res.data;
      });
    },
    // 获取统计数据文本
    getNumText(text, status) {
      const statusMap = {
        '0': 'incompleteNum', //待完善
        '1': 'completeNum', //预约中
        '1$1': 'waitAllowNum', //待分配
        '2': 'successNum', //预约成功
        '3': 'signNum', //已签单
        '-1': 'cancelNum' //取消预约
      };
      let num = this.statistics[statusMap[status]] || 0;
      if (status == 1) {
        // 商户后台预约中包含待分配
        num += this.statistics.waitAllowNum || 0;
      } else if (status == 'null') {
        num += this.statistics.cancelNum || 0;
        num += this.statistics.completeNum || 0;
        num += this.statistics.incompleteNum || 0;
        num += this.statistics.signNum || 0;
        num += this.statistics.successNum || 0;
        num += this.statistics.waitAllowNum || 0;
      }
      return (
        <div>
          {text}(<span style="color: #236dff">{num}</span>)
        </div>
      );
    },
    // 删除
    del(row) {
      this.$notice.inquiry('确定删除吗？').then(() => {
        this.listLoading = true;
        this.$http({
          url: '/buz/reservation/logic/del',
          type: 'GET',
          data: {
            id: row.id
          }
        }).then(res => {
          this.$notice.success('删除成功');
          this.getList();
        });
      });
    },
    // 下载行程单
    jumpTrip(row) {
      if (!row.bizTripUrl) {
        this.$notice.error('行程单不存在');
        return;
      }
      this.$units.downloadFun({
        url: '/upload/downloadByUrl',
        params: {
          url: row.bizTripUrl
        }
      });
    },
    // 导出
    daochu() {
      const params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      this.$units.downloadFun({
        url: '/buz/reservation/export',
        type: 'POST',
        params: params
      });
    },
    getIsMe(row) {
      return userInfo.tenantId === row.tenantId;
    }
  }
};
</script>
<style lang="scss" scoped>
.btns-left {
  display: flex;
  .ivu-btn + .ivu-btn {
    margin-left: 10px;
  }

  .ivu-btn + .ivu-upload {
    margin-left: 10px;
  }

  .ivu-upload + .ivu-btn {
    margin-left: 10px;
  }
}
</style>
